<template>
  <div class="box">
    <label for="title">标题：</label>
    <input id="title" v-model="data.title"/>
    <div class="item" v-for="(item, index) in data.manageList" :key="index">
      <i class="el-icon-close" @click="handleDel(index)"></i>
      <table>
        <tr>
          <td>
            <label>头像：</label>
          </td>
          <td align="left">
              <div class="image-upload" @click="uploadShow = true, idx = index">
                <img v-if="item.avatar" :src="item.avatar"/>
                <img v-else src="../../assets/image-upload.jpg" style="background-color: #dddee1"/>
              </div>
            <p class="tip">最佳尺寸：500x400px</p>
          </td>
        </tr>
        <tr>
          <td>
            <label for="name">姓名：</label>
          </td>
          <td>
            <input id="name" v-model="item.name"/>
          </td>
        </tr>
        <tr>
          <td>
            <label for="job">职位：</label>
          </td>
          <td>
            <input id="job" v-model="item.job"/>
          </td>
        </tr>
        <tr>
          <td>
            <label for="description">简介：</label>
          </td>
          <td>
            <input id="description" v-model="item.description"/>
          </td>
        </tr>
      </table>
    </div>
    <div style="text-align: left">
      <el-button type="primary" size="mini" @click="handleAddBtnClick">添加人员</el-button>
    </div>

    <imgPre v-if="uploadShow" :dialogVisible="uploadShow" @checkImg="handleImg" @onClose="uploadShow = false" />
  </div>
</template>
<script>
import imgPre from '../../components/uploadImg/imgPre'
export default {
  name: 'ManageTeamSetting',
  components: { imgPre },
  props: {
    data: Object
  },
  data () {
    return {
      uploadShow: false,
      idx: 0
    }
  },
  methods: {
    handleAddBtnClick: function () {
      this.data.manageList.push({
        avatar: '',
        name: '姓名',
        job: '职位',
        description: '简介'
      })
    },
    handleImg: function (data) {
      this.data.manageList[this.idx].avatar = data.url
      this.uploadShow = false
    },
    handleAvatarSuccess: function () {
      console.log()
    },
    handleDel: function (index) {
      this.data.manageList.splice(index, 1)
    }
  }
}
</script>
<style scoped>
label {
  font-size: 13px;
}
.box {
  padding: 35px;
}
#title {
  width: 385px;
  margin-bottom: 5px;
}
.item {
  padding: 20px 15px 15px 10px;
  background-color: #f9fafc;
  position: relative;
  border-radius: 6px;
  border: 1px solid #ededed;
  margin: 20px 0;
  position: relative;
}
.item .el-icon-close {
  position: absolute;
  right: -8px;
  top: -10px;
  font-size: 18px;
  cursor: pointer;
}
#name,
#job,
#description {
  width: 350px;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/manageTeam/ManageTeamSetting.vue